import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "./lib/index";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";

/**
 * Configuration du client React Query pour la gestion du cache et des requêtes
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

/**
 * Application racine YKE Multi_Services
 * Configure les routes, le layout global et les providers UI
 * © 2026 YKE Multi_Services
 */
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route 
                path={ROUTE_PATHS.HOME} 
                element={<Home />} 
              />
              <Route 
                path={ROUTE_PATHS.SERVICES} 
                element={<Services />} 
              />
              <Route 
                path={ROUTE_PATHS.ABOUT} 
                element={<About />} 
              />
              <Route 
                path={ROUTE_PATHS.CONTACT} 
                element={<Contact />} 
              />
              {/* Redirection ou page 404 par défaut vers l'accueil */}
              <Route 
                path="*" 
                element={<Home />} 
              />
            </Routes>
          </Layout>
        </BrowserRouter>
        
        {/* Composants de notification globaux */}
        <Toaster />
        <Sonner position="top-right" closeButton />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;